const SERVER_BASE_URL = `${process.env.REACT_APP_KIPONOS_SERVER_BASE_URL}`; 

const getServerUrl = (api) => {
  return process.env.NODE_ENV === 'development'
    ? `http://localhost/api${api}`
    : `${SERVER_BASE_URL}${api}`;
};


export const activationUrl = (aCode) => getServerUrl('/auth/activate/')+aCode;
export const joinUrl    = (joinCode) => getServerUrl('/auth/join/'+joinCode);       // SERVER_BASE_URL + '/auth/join/'+jcode;
export const createSdkUrl             = getServerUrl('/sdk-user/create');
export const loginUrl                 = getServerUrl('/login');
export const sendResetCodeUrl         = getServerUrl('/send-reset-code');
export const resetByCodeUrl           = getServerUrl('/reset-by-code');
export const configsUrl               = getServerUrl('/configs/');
export const joinSignUpUrl            = getServerUrl('/auth/join/signup');
export const signUpUrl                = getServerUrl('/signup');
export const landJoinUrl              = getServerUrl('/land-join');
export const reserveNameUrl           = getServerUrl('/reserve-name');
export const logoutUrl                = getServerUrl("/logout");
export const webSocketsServerUrl      = getServerUrl('/io-kiponos-websocket');

console.log('SERVER BASE URL: %s  NODE_ENV: %s',SERVER_BASE_URL, process.env.NODE_ENV);
